// extracted by mini-css-extract-plugin
module.exports = {"container":"Hero_container__28IuV","left":"Hero_left__2FWOs","right":"Hero_right__39fmf","text":"Hero_text__2ERI-","form":"Hero_form__10N_L","phone":"Hero_phone__3BQD5"};